import { defineRouting } from 'next-intl/routing';
import { Env } from '@/libs/env';

// 根据 region 获取对应的 locale 配置
const getLocaleConfig = (region: string) => {
  const configs = {
    'global': {
      // ✅ 静态导出优化：只保留 3 种主要语言，减少构建体积
      // 从 10 种 → 3 种：266页 → 84页，90MB → 49MB
      // 📝 如需扩展语言，取消注释相应行并添加翻译文件
      locales: [
        'en',     // 英语（默认）
        'hi',     // 印地语
        'pt',  // 巴西葡萄牙语
        // 'ur-PK',  // 乌尔都语（巴基斯坦） - 需要时取消注释
        // 'es-MX',  // 西班牙语（墨西哥） - 需要时取消注释
      ],
      defaultLocale: 'en' as const,
      prefixes: {
        'en': '/en',
        'hi': '/hi',
        'pt': '/pt',
        // 扩展语言的 URL 前缀（取消注释以启用）
        // 'ur-PK': '/ur',
        // 'es-MX': '/es',
      }
    },
    'india': {
      // 印度区域：英语和印地语
      locales: ['hi', 'en'],
      defaultLocale: 'en' as const,
      prefixes: {
        'en': '/en',
        'hi': '/hi',
      }
    },
    'brazil': {
      // 巴西区域：葡萄牙语和英语
      locales: ['pt', 'en'],
      defaultLocale: 'pt' as const,
      prefixes: {
        'pt': '/pt',
        'en': '/en',
      }
    },
  };

  return configs[region as keyof typeof configs] || configs['global'];
};

// 获取当前 region 的配置
const region = Env.REGION;
const config = getLocaleConfig(region);

export const routing = defineRouting({
  locales: config.locales,
  defaultLocale: config.defaultLocale,
  localePrefix: {
    mode: 'always', // 所有语言都显示语言前缀
    prefixes: config.prefixes
  },
  // ✅ 静态导出必须：禁用自动语言检测，完全依赖 URL 路径
  localeDetection: false,
});